/*
 * When the form must stop a rep working a task they do not hold. goserver
 * refuses /complete and /skip on a tiered task (level set) unless the caller
 * holds it or is a manager (409 NOT_HOLDER), so a claim that failed must not
 * leave the form silently editable. Legacy (level-less) tasks still fail open.
 */

import {
  CLAIM_FAILED,
  CLAIM_IDLE,
  CLAIM_NOT_ALLOWED
} from '../../util_components/instant_alert/claim';

export const NOT_HOLDER_CODE = 'NOT_HOLDER';

export const NOT_ALLOWED_TITLE =
  "You can't claim sales tasks; ask a manager to add you to the sales team";

export interface ClaimGateInput {
  state: string;
  reason?: string;
  terminal: boolean;
  tiered: boolean;
  is_manager: boolean;
  may_claim: boolean;
  // /me resolved: until then a skipped claim is not yet a verdict.
  me_loaded: boolean;
}

export interface ClaimGate {
  kind: 'not_allowed' | 'failed';
  title: string;
  detail: string;
}

// null = the form is workable.
export const claim_gate = (i: ClaimGateInput): ClaimGate | null => {
  if (i.terminal || !i.tiered || i.is_manager) return null;
  if (i.state === CLAIM_NOT_ALLOWED || (i.state === CLAIM_IDLE && i.me_loaded && !i.may_claim)) {
    return {
      kind: 'not_allowed',
      title: NOT_ALLOWED_TITLE,
      detail: 'Only the rep holding a task can complete, skip or message on it.'
    };
  }
  if (i.state === CLAIM_FAILED) {
    return {
      kind: 'failed',
      title: 'Could not claim this task',
      detail: i.reason || 'Retry the claim before you work this task.'
    };
  }
  return null;
};

interface NotHolderError {
  response?: {
    status?: number;
    data?: { error_code?: string; claimed_by_ops_uuid?: string; claimed_by_name?: string };
  };
}

// The toast for a 409 NOT_HOLDER from /complete or /skip; null for any other error.
export const not_holder_message = (e: unknown): string | null => {
  const res = (e as NotHolderError | null | undefined)?.response;
  if (res?.status !== 409 || res.data?.error_code !== NOT_HOLDER_CODE) return null;
  if (res.data.claimed_by_ops_uuid) {
    return `Held by ${res.data.claimed_by_name || 'another rep'}; only they can close this task`;
  }
  return 'You no longer hold this task; reopen it to claim it before closing';
};
